const A = "/assets/kitchens";

export const KITCHEN_LAYOUTS = [
  {
    name: "Island",
    note: "A freestanding worktop that cooks, seats and gathers — the centrepiece of open-plan homes.",
    image: `${A}/layout-island.jpg`,
  },
  {
    name: "L-Shaped",
    note: "Two walls, one continuous run — the most efficient working triangle for compact premium kitchens.",
    image: `${A}/layout-l-shape.jpg`,
  },
  {
    name: "U-Shaped",
    note: "Three walls of worktop and storage — maximum capacity for households that cook seriously.",
    image: `${A}/layout-u-shape.jpg`,
  },
  {
    name: "Parallel",
    note: "Two facing counters — the chef's galley, with sink, hob and prep never more than a step apart.",
    image: `${A}/layout-parallel.jpg`,
  },
  {
    name: "Straight",
    note: "One clean architectural run along a single wall — minimal, calm, made for open plans.",
    image: `${A}/layout-straight.jpg`,
  },
  {
    name: "Peninsula",
    note: "A connected island — all the seating and theatre of an island, where the room won't allow one.",
    image: `${A}/layout-peninsula.jpg`,
  },
];

export const KITCHEN_ANATOMY = [
  {
    title: "Carcass",
    text: "IS:710 boiling-water-proof marine plywood — the only core we allow near sinks, dishwashers and hobs. No particle board, ever.",
  },
  {
    title: "Shutters",
    text: "Factory-finished acrylic high-gloss, super-matte PU, lacquered glass or natural veneer — edge-banded and sealed against steam and turmeric.",
  },
  {
    title: "Hardware",
    text: "Häfele and Hettich throughout: soft-close hinges, full-extension tandem drawers, lift-up wall units and corner systems that actually use the corner.",
  },
  {
    title: "Countertops",
    text: "Cut from our own slabs — KalingaStone and Paradigm quartz for a non-porous, stain-proof worktop; granite and marble for those who ask.",
  },
  {
    title: "Lighting & power",
    text: "Under-cabinet LED task lighting, in-drawer charging, appliance garages and tall units planned around your oven, hob and refrigerator.",
  },
];

export const WARDROBES = [
  {
    name: "Sliding",
    note: "Floor-to-ceiling sliders in glass, lacquer or mirror — the full wardrobe, with zero door swing.",
    image: `${A}/wardrobe-sliding.jpg`,
  },
  {
    name: "Hinged",
    note: "The classic — every shelf visible at once, on soft-close hinges rated for decades of mornings.",
    image: `${A}/wardrobe-hinged.jpg`,
  },
  {
    name: "Walk-in",
    note: "A room of your own — open rails, island drawers, sensor lighting and a place for everything.",
    image: `${A}/wardrobe-walkin.jpg`,
  },
];

export const WARDROBE_INTERNALS =
  "Lofts to the ceiling, pull-out trays, trouser and saree racks, jewellery drawers, mirror shutters and sensor lighting — all riding on Häfele and Hettich fittings.";

export const PROCESS = [
  {
    step: "Consult & measure",
    text: "We visit, measure to the millimetre, and listen to how you cook, store and live.",
  },
  {
    step: "3D design",
    text: "Photorealistic views of your exact kitchen or wardrobe — approved by you before anything is built.",
  },
  {
    step: "Slab & finish selection",
    text: "Walk our showroom and choose the actual slab your countertop is cut from — something no kitchen studio can offer.",
  },
  {
    step: "Factory manufacture",
    text: "Precision-cut, edge-banded and pre-assembled off-site, so your home stays clean.",
  },
  {
    step: "Installation & handover",
    text: "Fitted, levelled and aligned by our own crew — with hardware warranties passed on to you.",
  },
];

export const STUDIO_BRANDS = [
  { name: "Häfele", img: "/assets/brands/hafele.png", h: "h-10 md:h-14" },
  { name: "Hettich", img: "/assets/brands/hettich.png", h: "h-12 md:h-16" },
  { name: "KalingaStone", img: "/assets/brands/kalingastone.png", h: "h-9 md:h-12" },
  { name: "Paradigm Quartz", img: "/assets/brands/paradigm.png", h: "h-16 md:h-24" },
];
